
export default function CoworkingAccess() {
  return (
    <section
      className="py-16 sm:py-24 md:py-32 bg-white"
      id="access"
      aria-labelledby="access-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <span className="inline-block px-3 py-1.5 bg-emerald-500/10 text-emerald-600 text-xs tracking-[0.15em] rounded-full mb-4 sm:mb-6">
            ACCESS
          </span>
          <h2
            id="access-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-extralight text-black mb-3 sm:mb-4 tracking-[0.1em]"
          >
            アクセス
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 max-w-6xl mx-auto">
          {/* Map */}
          <div className="aspect-[4/3] rounded-xl sm:rounded-2xl overflow-hidden shadow-md">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.358110203805!2d139.703283!3d35.6928042!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cda28d09a93%3A0x57fb4e4e13fc2f36!2z44Ki44OJ44Ob44OD44Kv5paw5a6_44OT44Or!5e0!3m2!1sja!2sjp!4v1752053062968!5m2!1sja!2sjp"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="コワーキングスペース by favy 新宿 地図"
            ></iframe>
          </div>

          {/* Info */}
          <div className="flex flex-col justify-center">
            <h3 className="text-2xl sm:text-3xl font-extralight text-black mb-6 tracking-wide">
              コワーキングスペース by favy
            </h3>

            <div className="space-y-5 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/10 rounded-lg flex-shrink-0">
                  <i
                    className="ri-map-pin-line text-lg text-emerald-600"
                    aria-hidden="true"
                  ></i>
                </div>
                <div>
                  <p className="text-xs text-black/40 font-extralight mb-1 tracking-wide">
                    住所
                  </p>
                  <address className="not-italic text-sm text-black/80 font-extralight leading-relaxed tracking-wide">
                    〒160-0022<br />
                    東京都新宿区新宿3丁目15−11<br />
                    アドホック新宿ビル 4F
                  </address>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/10 rounded-lg flex-shrink-0">
                  <i
                    className="ri-train-line text-lg text-emerald-600"
                    aria-hidden="true"
                  ></i>
                </div>
                <div>
                  <p className="text-xs text-black/40 font-extralight mb-1 tracking-wide">
                    最寄り駅
                  </p>
                  <ul className="text-sm text-black/80 font-extralight leading-relaxed tracking-wide space-y-1">
                    <li>東京メトロ丸ノ内線 新宿三丁目駅 徒歩2分</li>
                    <li>JR線 新宿駅 徒歩5分</li>
                    <li>西武鉄道新宿線 西武新宿駅 徒歩5分</li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/10 rounded-lg flex-shrink-0">
                  <i
                    className="ri-time-line text-lg text-emerald-600"
                    aria-hidden="true"
                  ></i>
                </div>
                <div>
                  <p className="text-xs text-black/40 font-extralight mb-1 tracking-wide">
                    営業時間
                  </p>
                  <p className="text-sm text-black/80 font-extralight tracking-wide">
                    9:00〜23:00
                  </p>
                  <p className="text-xs text-black/50 font-extralight tracking-wide mt-1">
                    窓口対応は11:00-18:00（平日のみ）
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/10 rounded-lg flex-shrink-0">
                  <i
                    className="ri-instagram-line text-lg text-emerald-600"
                    aria-hidden="true"
                  ></i>
                </div>
                <div>
                  <p className="text-xs text-black/40 font-extralight mb-1 tracking-wide">
                    お知らせ
                  </p>
                  <p className="text-sm text-black/80 font-extralight tracking-wide mb-1">
                    営業時間やイベントの予定は公式Instagramでご確認ください
                  </p>
                  <a
                    href="https://www.instagram.com/favy_coworkingspace/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-sm text-emerald-600 hover:text-emerald-700 font-light tracking-wide cursor-pointer inline-flex items-center gap-1"
                  >
                    @favy_coworkingspace
                    <i className="ri-external-link-line text-xs" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://pass.workhub.site/spaces/drop-in/detail/KmPzAOl3HSsGdIqqdLxK"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center justify-center px-6 py-3.5 bg-emerald-500 text-white text-sm font-light tracking-[0.1em] hover:bg-emerald-600 transition-colors whitespace-nowrap rounded-lg cursor-pointer"
              >
                30分単位で使う
                <i className="ri-external-link-line ml-2" aria-hidden="true"></i>
              </a>
              <a
                href="https://forms.gle/kcdbjKEZi2kF7gBB8"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center justify-center px-6 py-3.5 bg-black text-white text-sm font-light tracking-[0.1em] hover:bg-black/80 transition-colors whitespace-nowrap rounded-lg cursor-pointer"
              >
                <i className="ri-calendar-line mr-1.5" aria-hidden="true"></i>
                継続利用の内見予約
              </a>
            </div>
          </div>
        </div>

        {/* Notes */}
        <div className="mt-12 sm:mt-16 max-w-3xl mx-auto">
          <div className="bg-gray-50 rounded-xl p-5 sm:p-6">
            <h4 className="text-sm font-light text-black mb-3 tracking-wide">
              利用上の注意事項
            </h4>
            <ul className="text-xs text-black/50 font-extralight space-y-1.5 tracking-wide leading-relaxed">
              <li>※ 他の利用者さまの迷惑になる行為はおやめください。</li>
              <li>※ 泥酔された方のご利用はお断りさせていただきます。</li>
              <li>※ 長時間の睡眠・宿泊はできません。</li>
              <li>※ シャワー設備はございません。</li>
              <li>※ 施設内での写真・動画撮影時には他のお客さまが映り込まないようにご注意ください。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
